/*******************
 * EXPERIMENT VIEWED — PAYLOAD ENRICHMENT
 *******************/
//
// Optimizely tells Segment when a user sees an experiment by
// calling analytics.track('Experiment Viewed', { ... }).
//
// The problem: Optimizely fires this call very early — sometimes
// before our code has a chance to add extra data to it.
// We would like to add optimizelyEndUserId property to the payload
//
// The fix: we watch for the moment Segment becomes available on
// the page, and immediately wrap its track() function with our
// own version. That way, every time Optimizely (or anyone) calls
// analytics.track('Experiment Viewed'), our version runs first,
// adds optimizelyEndUserId to the data, then passes it along to
// Segment as normal.
//
// All destinations automatically
// receive the enriched version — nothing else needs to change.
(function () {
  function getCookieValue(name) {
    var cookie = document.cookie.split('; ').find(function (value) {
      return value.startsWith(name + '=');
    });

    return cookie ? decodeURIComponent(cookie.slice(name.length + 1)) : null;
  }

  function enrichExperimentViewed(properties) {
    return Object.assign({}, properties, {
      optimizelyEndUserId: (properties && properties.optimizelyEndUserId) || getCookieValue('optimizelyEndUserId'),
    });
  }

  function wrapTrack(analyticsInstance) {
    if (!analyticsInstance || typeof analyticsInstance.track !== 'function') return;
    if (analyticsInstance.__trackWrapped) return;

    var originalTrack = analyticsInstance.track.bind(analyticsInstance);

    analyticsInstance.track = function (eventName, properties, options, callback) {
      if (typeof eventName === 'string' && eventName.toLowerCase() === 'experiment viewed') {
        properties = enrichExperimentViewed(properties);
      }
      return originalTrack(eventName, properties, options, callback);
    };

    analyticsInstance.__trackWrapped = true;
  }

  var _analytics = window.analytics;

  Object.defineProperty(window, 'analytics', {
    configurable: true,
    get: function () {
      return _analytics;
    },
    set: function (newVal) {
      _analytics = newVal;
      wrapTrack(newVal);
    },
  });

  if (_analytics) wrapTrack(_analytics);
})();

/*************** end of EXPERIMENT VIEWED — PAYLOAD ENRICHMENT */

function parseMoneyValue(value) {
  if (typeof value !== 'string') return null;

  const normalized = value.replace(/[^0-9.-]/g, '');
  if (!normalized) return null;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

function getTrackFunction() {
  if (typeof window === 'undefined') return null;
  if (!window.analytics || typeof window.analytics.track !== 'function') return null;
  return window.analytics.track.bind(window.analytics);
}

function safeTrack(eventName, payload) {
  const track = getTrackFunction();
  if (!track) return;
  track(eventName, payload);
}

//Event will fire when we click on "Add to Box" button of product card
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-product-card-add-to-box]');
  if (!btn) return;

  const type = btn.dataset.type; // 'add-on', 'deal'

  const eventName =
    {
      'add-on': 'Addon Quantity Increased',
      deal: 'Member Deal Quantity Increased',
    }[type] || 'Product Added';

  const price = parseMoneyValue(btn.dataset.productPrice);

  safeTrack(eventName, {
    variant_id: btn.dataset.variantId,
    product_id: btn.dataset.productId,
    sku: btn.dataset.productSku,
    name: btn.dataset.productName,
    price,
    quantity: 1,
    quantity_delta: 1,
    total_delta: price,
    total: price,
    type: type,
  });
});

//Event will fire when we click add or minus quantity buttons of product card
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-action="add"], [data-action="minus"]');
  if (!btn) return;

  const card = btn.closest('product-card');
  if (!card) return;

  const addToBoxBtn = card.querySelector('[data-product-card-add-to-box]');
  if (!addToBoxBtn) return;

  const type = addToBoxBtn.dataset.type;
  const action = btn.dataset.action;
  const currentQuantityRaw = Number.parseInt(card.querySelector('[data-quantity-input]')?.value, 10);
  const currentQuantity = Number.isFinite(currentQuantityRaw) ? currentQuantityRaw : 0;
  const quantityDelta = action === 'add' ? 1 : -1;
  const newQuantity = currentQuantity + quantityDelta;
  const price = parseMoneyValue(addToBoxBtn.dataset.productPrice);

  let eventName;
  if (type === 'deal') {
    eventName = action === 'add' ? 'Member Deal Quantity Increased' : 'Member Deal Quantity Reduced';
  } else if (type === 'add-on') {
    eventName = action === 'add' ? 'Addon Quantity Increased' : 'Addon Quantity Reduced';
  } else {
    eventName = action === 'add' ? 'Product Added' : 'Product Removed';
  }

  safeTrack(eventName, {
    variant_id: addToBoxBtn.dataset.variantId,
    product_id: addToBoxBtn.dataset.productId,
    sku: addToBoxBtn.dataset.productSku,
    name: addToBoxBtn.dataset.productName,
    price: price,
    quantity: Math.max(0, newQuantity),
    quantity_delta: quantityDelta,
    total: price !== null ? price * Math.max(0, newQuantity) : null,
    total_delta: price !== null ? price * quantityDelta : null,
    type: type,
  });
});

async function trackCheckoutOptIn(email, optInType) {
  const eventName = optInType === 'marketing-opt-in' ? 'Checkout Marketing Opt In' : 'Checkout Promo Opt In';
  const selectedTile = document.querySelector('[data-offer-tile].selected');
  const discountCode = document.querySelector('[data-reference-input]')?.value;
  let totalDiscount = null;

  let bundledItems = [];
  let offerType = '';
  try {
    const bundledItemsRaw = selectedTile?.querySelector('[data-offer-bundled-items]')?.textContent;
    const bundledOffer = bundledItemsRaw ? JSON.parse(bundledItemsRaw) : {};
    bundledItems = bundledOffer.items || [];
    offerType = bundledOffer.type || '';
  } catch (error) {
    console.warn('Unable to parse bundled items from selected offer tile.', error);
    bundledItems = [];
  }

  const offerDetails = {
    id: selectedTile?.dataset.offerProductId || '',
    sku: selectedTile?.dataset.offerSku || '',
    title: selectedTile?.querySelector('[id^="offer-title"]')?.textContent?.trim() || selectedTile?.dataset.offerTitle || '',
  };

  const curatedOffer =
    bundledItems.length > 0
      ? {
          offer_description: offerDetails.title || '',
          offer_id: offerDetails.id,
          offer_sku: offerDetails.sku || null,
          offer_type: offerType,
          bundled_items: bundledItems,
        }
      : null;

  // ─── Set localStorage ───
  window.localStorage.setItem(
    'subscriptionBuilderSelectedOfferDetails',
    JSON.stringify(curatedOffer ? { ...offerDetails, curated_offer: curatedOffer } : offerDetails)
  );

  if (email) {
    const anonymousId = document.cookie
      .split('; ')
      .find(function (row) {
        return row.startsWith('ajs_anonymous_id=');
      })
      ?.split('=')[1];

    if (window.analytics && typeof window.analytics.identify === 'function') {
      const identifyOptions = anonymousId ? { anonymousId: decodeURIComponent(anonymousId) } : undefined;

      await new Promise((resolve) => {
        window.analytics.identify({ email: email }, identifyOptions, resolve);
      });
    }
  }

  const queryParams = new URLSearchParams(window.location.search);
  // DIGX-346: `source_path` is the page path the email was submitted from, so the
  // same event can be told apart across landers (/get-started) and the homepage
  // email capture module (/). Path only, no query string or hash. Marketing
  // opt-in only; the promo opt-in payload is unchanged.
  const sourcePath = optInType === 'marketing-opt-in' ? window.location.pathname : undefined;
  safeTrack(eventName, {
    offer_variant_id: selectedTile?.dataset.variantId,
    offer_description: offerDetails.title,
    offer_id: offerDetails.id,
    offer_sku: offerDetails.sku,
    path: window.location.pathname,
    source_path: sourcePath,
    url: window.location.href,
    domain: window.location.hostname,
    discount_code: discountCode || null,
    utmCampaign: queryParams.get('utm_campaign') ?? undefined,
    utmContent: queryParams.get('utm_content') ?? undefined,
    utmMedium: queryParams.get('utm_medium') ?? undefined,
    utmSource: queryParams.get('utm_source') ?? undefined,
    utmTerm: queryParams.get('utm_term') ?? undefined,
    email: email ? email : null,
    curated_offer: curatedOffer || null,
  });

  try {
    const discountSummaryRaw = window.localStorage.getItem('subscriptionBuilderCartDiscountSummary');
    if (discountSummaryRaw) {
      const discountSummary = JSON.parse(discountSummaryRaw);
      const parsedTotalDiscount = Number(discountSummary?.total_discount);
      if (Number.isFinite(parsedTotalDiscount)) {
        totalDiscount = parsedTotalDiscount;
      }
    }
  } catch (error) {
    console.warn('Unable to parse subscriptionBuilderCartDiscountSummary from localStorage.', error);
  }

  safeTrack('Cart Updated', {
    url: window.location.href,
    plan_name: null,
    plan_type: null,
    plan_frequency_weeks: null,
    plan_size: null,
    offer_variant_id: selectedTile?.dataset.variantId,
    offer_sku: offerDetails.sku,
    offer_id: offerDetails.id,
    offer_banner_description: offerDetails.title ?? null,
    products: [],
    discount_code: discountCode || null,
    discount: totalDiscount !== null ? totalDiscount / 100 : null,
    curated_offer: curatedOffer || null,
  });
}

const EMAIL_VALIDATION_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function isValidEmail(email) {
  return typeof email === 'string' && EMAIL_VALIDATION_REGEX.test(email.trim());
}

// ─── Email form button on a lander ───
document.addEventListener('submit', async function (e) {
  const form = e.target.closest('#newsletter-form');
  if (!form) return;
  const email = form.querySelector('input[type="email"]')?.value;
  if (!isValidEmail(email)) return;
  await trackCheckoutOptIn(email.trim(), 'marketing-opt-in');
});

// ─── Direct link button on a lander ───
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('[data-submit]');
  if (!btn) return;
  await trackCheckoutOptIn(null, 'promo-opt-in');
});

// Products Viewed Event
const viewedProductQueue = [];
let viewedProductTimer = null;

function flushViewedProducts() {
  if (!viewedProductQueue.length) return;

  safeTrack('Products Viewed', {
    products: [...viewedProductQueue],
  });

  viewedProductQueue.length = 0; // clear queue like setEventQueue([])
}

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const card = entry.target;
      const btn = card.querySelector('[data-product-card-add-to-box]');
      if (!btn) return;

      viewedProductQueue.push({
        shopify_product_variant_id: btn.dataset.variantId,
        shopify_product_id: btn.dataset.productId,
        sku: btn.dataset.productSku,
        product_type: btn.dataset.productType,
        ts: Math.floor(Date.now() / 1000),
      });

      // ─── setInterval equivalent - reset every 2s ───
      clearTimeout(viewedProductTimer);
      viewedProductTimer = setTimeout(flushViewedProducts, 2000);
    });
  },
  { threshold: 0.5 }
);

function observeProductCards(root = document) {
  root.querySelectorAll('product-card').forEach((card) => {
    observer.observe(card);
  });
}

// observe all product cards
observeProductCards();

function getCollectionHandleFromPath(pathname) {
  const match = pathname.match(/^\/collections\/([^/]+)\/?$/);
  return match ? decodeURIComponent(match[1]) : null;
}

// ─── Product List Viewed Event ───
// Tracks the last URL key for which Product List Viewed was fired,
// to prevent duplicate events on re-renders or replaceState calls
let lastTrackedCollectionListKey = null;

function trackPageListViewed() {
  // Require the collection container to avoid firing on PDPs that include /collections/ in the URL.
  const collectionNode = document.querySelector('.collection[data-products-count]');
  if (!collectionNode) return;

  const collectionHandle = getCollectionHandleFromPath(window.location.pathname);
  if (!collectionHandle) return;

  const listKey = `${window.location.pathname}${window.location.search}`;
  if (lastTrackedCollectionListKey === listKey) return;

  const collectionUrl = window.location.href;

  // Read products count from the collection container data attribute
  const productsCountRaw = collectionNode?.dataset.productsCount;
  const totalProductsCount =
    productsCountRaw !== '' && productsCountRaw !== undefined && Number.isFinite(Number(productsCountRaw))
      ? Number(productsCountRaw)
      : null;

  // Build the products array from visible product cards.
  // Fall back to host element data when add-to-box buttons are hidden.
  const products = [];
  document.querySelectorAll('product-card').forEach((card, index) => {
    const btn = card.querySelector('[data-product-card-add-to-box]');

    products.push({
      shopify_product_variant_id: btn?.dataset.variantId || card.dataset.variantId || null,
      shopify_product_id: btn?.dataset.productId || null,
      sku: btn?.dataset.productSku || null,
      name: btn?.dataset.productName || null,
      product_type: btn?.dataset.productType || null,
      price: parseMoneyValue(btn?.dataset.productPrice),
      position: index + 1,
    });
  });

  // Mark as tracked before firing to prevent duplicate events.
  lastTrackedCollectionListKey = listKey;

  safeTrack('Product List Viewed', {
    collection_handle: collectionHandle,
    collection_url: collectionUrl,
    products_count: products.length,
    products_visible_count: products.length,
    products_total_count: totalProductsCount,
    products,
  });
}

// On initial page load, wait for the page to fully load before tracking
// so that Segment and the DOM are both ready
if (document.readyState === 'complete') {
  trackPageListViewed();
} else {
  window.addEventListener('load', trackPageListViewed);
}

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    trackPageListViewed();
    observeProductCards();
  }
});

// Re-run tracking after filters/sort links replace the collection section HTML.
document.addEventListener('collection:rendered', function (event) {
  // Do not fire Product List Viewed on in-page filter/sort updates.
  observeProductCards(event.target);
});
